export enum DatabaseUsageRange {
    TwentyFourHours = '24h',
    ThirtyDays = '30d',
    NinetyDays = '90d',
}